import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import Contrato from "../classes/Contrato";
import ContratoDataset from "../data/ContratoDataSet";
import { useTranslation } from "react-i18next";

export default function AutocompleteContrato(props: AutocompleteCentroProps) {
  const { t } = useTranslation();
  const codigoFornecedorSap = Number(
    localStorage.getItem("CodigoFornecedorSAPSelecionado")
  );
  const dataSet = new ContratoDataset();
  const [data, setData] = useState<Contrato[]>([]);
  const [dataFilter, setDataFilter] = useState<Contrato[]>([]);

  useEffect(() => {
    dataSet.ListarAtivos(codigoFornecedorSap).then((result) => setData(result));
  }, []);

  useEffect(() => {
    if (
      dataFilter !== null &&
      dataFilter !== undefined &&
      dataFilter.length === 1
    )
      localStorage.setItem(
        "ContratoSelecionado",
        String(dataFilter[0].numeroContrato)
      );
    else if (dataFilter.length !== 1)
      localStorage.removeItem("ContratoSelecionado");
  }, [dataFilter]);

  const handlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDataFilter(
      data.filter((f) =>
        f.numeroContrato.toString().startsWith(event.target.value)
      )
    );
  };

  return (
    <>
      <Autocomplete
        freeSolo
        id="autocompleteContrato"
        disableClearable
        options={data.map((option: any) => option.numeroContrato)}
        onChange={(e) => {
          setDataFilter(
            data.filter(
              (f) =>
                f.numeroContrato.toString() ===
                String(e.currentTarget.textContent)
            )
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("common.autoComplete.contrato.label")}
            InputProps={{
              ...params.InputProps,
              type: "search",
            }}
            onChange={handlerOnChange}
          />
        )}
      />
    </>
  );
}

interface AutocompleteCentroProps {}